var ReCaptchaActionOptions = /*#__PURE__*/function (ReCaptchaActionOptions) {
  ReCaptchaActionOptions["ResendEmailRequest"] = "resend_email_request";
  ReCaptchaActionOptions["UserExistence"] = "user_existence";
  ReCaptchaActionOptions["UsernameExistence"] = "username_existence";
  return ReCaptchaActionOptions;
}({});

export { ReCaptchaActionOptions, ReCaptchaActionOptions as default };
//# sourceMappingURL=index.js.map
